import React, { useEffect, useState } from 'react';

export default function DocumentenTab({ klantId }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/klanten/' + klantId + '/documenten', {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
    }).then(r => r.json()).then(d => { setDocs(d.documenten || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [klantId]);

  const downloadDoc = async (docId, filename) => {
    try {
      const res = await fetch('/api/klanten/' + klantId + '/documenten/' + docId + '/download', {
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
      });
      if (!res.ok) throw new Error('Download faalde');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { alert('Download mislukt: ' + e.message); }
  };

  if (loading) return <div style={{padding:'20px'}}>Laden...</div>;
  if (docs.length === 0) return <div style={{padding:'20px',color:'#6b7280'}}>📁 Nog geen documenten voor deze klant.</div>;

  return (
    <div style={{padding:'20px'}}>
      <h3 style={{fontSize:'16px',fontWeight:'600',margin:'0 0 16px'}}>📁 Documenten ({docs.length})</h3>
      <ul style={{listStyle:'none',padding:0,margin:0}}>
        {docs.map(d => (
          <li key={d.id} style={{padding:'12px 16px',borderBottom:'1px solid #e5e7eb',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <strong>{d.titel || d.bestandsnaam}</strong>
              <div style={{fontSize:'12px',color:'#6b7280'}}>
                {new Date(d.created_at).toLocaleString('nl-NL')} · {d.bron_type}
                {d.aangemaakt_door_naam ? ' · door ' + d.aangemaakt_door_naam : ''}
              </div>
            </div>
            <button onClick={() => downloadDoc(d.id, d.bestandsnaam)} style={{padding:'6px 12px',background:'#3b82f6',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
              📥 Download
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
